// Arquia: Mobile product card gallery — 2-image scroll-snap + swatch +X truncation
(function () {

  /* ── Gallery: scroll → update progress bar ─────────────────── */
  // Always 2 slides → segmentWidth = 50%
  function initGalleries(root) {
    var galleries = (root || document).querySelectorAll('[data-mobile-gallery]');
    galleries.forEach(function (gallery) {
      if (gallery._galleryInit) return;
      gallery._galleryInit = true;

      var card = gallery.closest('[data-grid-item]');
      if (!card) return;
      var bar = card.querySelector('.product-item__gallery__bar');
      if (!bar) return;

      gallery.addEventListener('scroll', function () {
        var sw = gallery.offsetWidth;
        if (!sw) return;
        var idx = Math.round(gallery.scrollLeft / sw);
        bar.style.marginLeft = (idx * 50) + '%';
      }, { passive: true });
    });
  }

  /* ── Swatch truncation — only when > 4 swatches ────────────── */
  function truncateSwatch(gs) {
    if (gs._swatchTruncated) return;
    gs._swatchPending = true;
    var buttons = Array.from(gs.querySelectorAll('[data-swatch-button]'));

    // Only truncate if more than 4 swatches; ≤4 always show all
    if (buttons.length <= 4) return;

    requestAnimationFrame(function () {
      buttons = Array.from(gs.querySelectorAll('[data-swatch-button]'));
      if (!buttons.length) return;

      var containerW = gs.offsetWidth;
      if (!containerW) return;

      // Measure first swatch button (excludes 5px L + 5px R margin from theme)
      var r0 = buttons[0].getBoundingClientRect();
      if (!r0.width) return;
      var btnW = r0.width + 10; // +10 for 5px margin each side
      var PLUS_W = 20 + 10;     // 20px button + margin

      var totalW = 0;
      var fitCount = 0;
      for (var i = 0; i < buttons.length; i++) {
        if (totalW + btnW + PLUS_W > containerW) break;
        totalW += btnW;
        fitCount++;
      }

      // If everything fits (even with +X reserved), no truncation needed
      if (fitCount >= buttons.length) return;

      gs._swatchTruncated = true;
      buttons.forEach(function (btn, i) {
        if (i >= fitCount) btn.style.display = 'none';
      });

      var hiddenCount = buttons.length - fitCount;
      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'swatch__expand-btn';
      plusBtn.textContent = '+' + hiddenCount;
      plusBtn.setAttribute('aria-label', 'Show ' + hiddenCount + ' more colours');

      plusBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        buttons.forEach(function (btn) { btn.style.display = ''; });
        plusBtn.remove();
        gs._swatchTruncated = false;
        gs.classList.add('is-expanded');
        // Unlock overflow on ancestor containers
        var fieldset = gs.closest('.radio__fieldset--pgi');
        if (fieldset) { fieldset.style.overflow = 'visible'; fieldset.style.height = 'auto'; }
        var holder = gs.closest('.product-item__swatches__holder');
        if (holder) holder.style.overflow = 'visible';
      });

      gs.appendChild(plusBtn);
    });
  }

  function initSwatchTruncation(root) {
    (root || document).querySelectorAll('[data-grid-item] grid-swatch').forEach(function (gs) {
      if (gs._swatchInit) return;       // ← stable, never cleared
      gs._swatchInit = true;            // ← set immediately on first visit
      if (gs.querySelector('[data-swatch-button]')) { truncateSwatch(gs); return; }
      var obs = new MutationObserver(function () {
        if (gs.querySelector('[data-swatch-button]')) {
          obs.disconnect();             // ← no more _swatchObserver = null needed
          truncateSwatch(gs);
        }
      });
      obs.observe(gs, { childList: true });
      gs._swatchObserver = obs;
    });
  }

  /* ── Swatch tap: rebuild gallery slides for selected colour ─── */
  // Each product-item__bg__inner has:
  //   - its innerHTML = the rendered featured image for that colour
  //   - data-variant-hover-image = URL of the second image (same logic as desktop double_img)
  // On swatch tap, wait for GridSwatch to apply is-visible, then clone the
  // active inner's image into slide 1 and load slide 2 from data-variant-hover-image.
  function initSwatchGallery(root) {
    (root || document).querySelectorAll('[data-grid-item]').forEach(function (card) {
      if (card._swatchGalleryBound) return;
      card._swatchGalleryBound = true;
      card.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-swatch-button]');
        if (!btn) return;
        // Give GridSwatch time to apply is-visible
        setTimeout(function () {
          var activeInner = card.querySelector('.product-item__bg__inner.is-visible');
          if (!activeInner) return;

          var slide2Url = activeInner.getAttribute('data-variant-hover-image');
          var gallery = card.querySelector('[data-mobile-gallery]');
          var progress = card.querySelector('.product-item__gallery__progress');
          if (!gallery) return;

          var slides = gallery.querySelectorAll('.product-item__gallery__slide');
          if (slides.length < 2) return;

          // Slide 1: clone the fully-rendered image markup from the active bg__inner
          slides[0].innerHTML = activeInner.innerHTML;

          // Slide 2: update the existing img to the hover image URL
          if (slide2Url) {
            var img2 = slides[1].querySelector('img');
            if (img2) {
              img2.src = slide2Url;
              img2.srcset = slide2Url;
            }
          }

          // Reset scroll to first slide and restore gallery
          gallery.scrollLeft = 0;
          var bar = card.querySelector('.product-item__gallery__bar');
          if (bar) bar.style.marginLeft = '0%';
          gallery.style.display = '';
          if (progress) progress.style.display = '';
        }, 0);
      });
    });
  }

  /* ── Gallery tap → navigate to product page ─────────────────── */
  // The gallery (position:absolute) intercepts taps on the underlying product link.
  // A tap (no swipe) on the gallery should navigate to the product URL.
  // Swipes are handled as scroll events by the browser and do NOT fire click.
  function initGalleryLinks(root) {
    (root || document).querySelectorAll('[data-grid-item]').forEach(function (card) {
      if (card._galleryLinkBound) return;
      card._galleryLinkBound = true;
      var gallery = card.querySelector('[data-mobile-gallery]');
      if (!gallery) return;
      var link = card.querySelector('[data-product-link]');
      if (!link) return;
      // Read href at click time — the inline card JS updates link.href
      // on swatch tap, so reading it live matches desktop behaviour exactly.
      gallery.addEventListener('click', function () {
        window.location.href = link.getAttribute('href') || link.getAttribute('data-product-link');
      });
    });
  }

  /* ── Boot ───────────────────────────────────────────────────── */
  function init(root) {
    initGalleries(root);
    initSwatchTruncation(root);
    initSwatchGallery(root);
    initGalleryLinks(root);
  }

  /* ── Re-execute inline scripts for AJAX-inserted cards ──────── */
  function reinitAjaxScripts(container) {
    if (!container) return;
    container.querySelectorAll('script').forEach(function (oldScript) {
      // If we've already re-run this script, skip it to prevent double-add-to-cart
      if (oldScript.dataset.executed) return;

      var newScript = document.createElement('script');
      newScript.textContent = oldScript.textContent;
      newScript.dataset.executed = "true"; // Mark as executed

      if (oldScript.parentNode) {
        oldScript.parentNode.replaceChild(newScript, oldScript);
      }
    });
  }

  /* ── Watch for AJAX-inserted recommendation cards ───────────── */
  // related-products.js inserts HTML into [data-related-section] via innerHTML.
  // A MutationObserver detects the insertion, then we re-run the card scripts.
  function observeRecommendations() {
    var relatedSection = document.querySelector('[data-related-section]');
    if (!relatedSection || relatedSection._recObserved) return;
    relatedSection._recObserved = true;
    var obs = new MutationObserver(function (mutations) {
      if (!mutations.some(function (m) { return m.addedNodes.length > 0; })) return;
      obs.disconnect();
      setTimeout(function () {
        reinitAjaxScripts(relatedSection);
        init(relatedSection);
      }, 50);
    });
    obs.observe(relatedSection, { childList: true });
  }

  /* ── Watch for filter/sort AJAX grid replacements ────────────── */
  // collection-filters-form.js replaces [data-products-grid].innerHTML on every
  // filter or sort change. Inline <script> tags injected via innerHTML never
  // re-execute (browser security), so all card functionality (active swatch,
  // quick-add hover, click-to-select, gallery tap) breaks. This observer detects
  // childList changes on the grid element and re-runs both the inline scripts and
  // our own init functions on the fresh card nodes.
  function observeProductsGrid() {
    var grid = document.querySelector('[data-products-grid]');
    if (!grid || grid._filterObserved) return;
    grid._filterObserved = true;
    var obs = new MutationObserver(function (mutations) {
      if (!mutations.some(function (m) { return m.addedNodes.length > 0; })) return;
      // Debounce: collection-filters-form may fire multiple childList records
      // for a single innerHTML swap.
      clearTimeout(grid._filterReinit);
      grid._filterReinit = setTimeout(function () {
        reinitAjaxScripts(grid);
        init(grid);
      }, 50);
    });
    obs.observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      observeRecommendations();
      observeProductsGrid();
      // Re-run after 150ms: <grid-swatch> custom elements render their buttons
      // asynchronously after connectedCallback, so some cards may not have
      // buttons ready when init() first fires on DOMContentLoaded.
      setTimeout(function () { init(); }, 150);
    });
  } else {
    init();
    observeRecommendations();
    observeProductsGrid();
    setTimeout(function () { init(); }, 150);
  }
  document.addEventListener('theme:filter:update', function () {
    var grid = document.querySelector('[data-products-grid]');
    if (grid) { reinitAjaxScripts(grid); init(grid); } else { init(); }
  });
  document.addEventListener('theme:section:load', function (e) { init(e.target); });
  let isTouchTap = false;

  // 1. Detect an actual physical tap on the screen
  document.addEventListener('touchstart', function() {
      isTouchTap = true;
      // Keep the "kill window" open just long enough to catch the synthetic hover
      setTimeout(function() { isTouchTap = false; }, 500);
  }, { passive: true, capture: true });

  // 2. Intercept hover events
  document.addEventListener('mouseenter', function(e) {
      // If no tap just happened (meaning this is a normal desktop mouse), BAIL OUT instantly.
      if (!isTouchTap) return;

      // Safety check: ensure e.target is a valid HTML element to prevent JS errors on SVGs
      if (!e.target || typeof e.target.closest !== 'function') return;

      // Kill the synthetic hover ONLY if it's targeting our swatch
      var tooltip = e.target.closest('tooltip-component[data-swatch-button]');
      if (tooltip) {
          e.stopPropagation();
      }
  }, true);
})();